var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsDateString, IsEmail, IsOptional, IsString } from 'class-validator';
export class SendEmailDto {
    toMail;
    subject;
    htmlBody;
    fromMail;
    fromName;
    textBody;
    sentDate;
    attachmentFilename;
}
__decorate([
    IsEmail(),
    __metadata("design:type", String)
], SendEmailDto.prototype, "toMail", void 0);
__decorate([
    IsEmail(),
    __metadata("design:type", String)
], SendEmailDto.prototype, "subject", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], SendEmailDto.prototype, "htmlBody", void 0);
__decorate([
    IsEmail(),
    IsOptional(),
    __metadata("design:type", String)
], SendEmailDto.prototype, "fromMail", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], SendEmailDto.prototype, "fromName", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], SendEmailDto.prototype, "textBody", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    __metadata("design:type", Object)
], SendEmailDto.prototype, "sentDate", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], SendEmailDto.prototype, "attachmentFilename", void 0);
//# sourceMappingURL=send-email.dto.js.map